import Experience from "@folio-2026/experience"
import { useWorksStore } from "@folio-2026/section-works"
import { EVENTS } from "@folio-2026/shared"
import { useEffect, useRef } from "react"

export default function useSectionReady(sectionName: keyof typeof EVENTS) {
  const experience = useRef(Experience.getInstance())
  const { isSectionReady, setIsSectionReady } = useWorksStore()

  useEffect(() => {
    const sectionEvents = EVENTS[sectionName]

    if (!sectionEvents || !("SectionReady" in sectionEvents)) {
      return
    }

    experience.current.on(sectionEvents.SectionReady, () => {
      setIsSectionReady(true)
    })
  }, [setIsSectionReady, sectionName])

  return isSectionReady
}
